import { ApckDataMarkdown } from './markdown_apckdata';
import { ApckNarrativeMeta } from './narrative_meta';

export const ApckNarrativeAlerts = {
    // TODO: Currently, we only output image attachments properly.
    // Refactor error block to handle any attachment in the highlighted error message.
    components: {
        'apck-data-markdown': ApckDataMarkdown,
        'apck-narrative-meta': ApckNarrativeMeta,
    },
    props: {
        narrative: {
            type: Object,
            default: null,
        },
        scanSettingsUrl: {
            type: String,
            default: null,
        },
        goScriptUrl: {
            type: String,
            default: null,
        },
    },
    methods: {
        openFix() {
            window.parent.open(this.scanSettingsUrl, '_blank');
        },
        openGoScript() {
            window.parent.open(this.goScriptUrl, '_blank');
        },
    },
    computed: {
        nodes() {
            // Function to find the latest error and critical node.
            // Output the critical node with the fix button if it's an auth failure.
            // Output the error node with a details link.
            let error = null;
            let critical = null;

            function walk(node) {
                if (!node) return;
                if (Array.isArray(node)) {
                    node.forEach(walk);
                    return;
                }
                if (node.verbosity === 'ERROR') error = node;
                else if (node.verbosity === 'CRITICAL') critical = node;
                if (Array.isArray(node.content)) node.content.forEach(walk);
            }

            walk(this.narrative && this.narrative.content);
            return { error, critical };
        },
        isImage() {
            if (!this.nodes.error) return false;
            return (this.nodes.error.file_type || '').toLowerCase().includes('png');
        },
        showFix() {
            if (!this.scanSettingsUrl || !this.nodes.critical) return false;
            const elements = (this.nodes.critical.markdown || {}).elements || [];
            return JSON.stringify(elements).toLowerCase().includes('auth');
        },
    },
    template: `
        <div
            v-if="nodes.critical || nodes.error"
            class="new-ui"
        >
            <ui-layout direction="column" gap="2">
                <ui-panel-base v-if="nodes.critical" color="red" direction="column" align="start" gap="2">
                    <apck-data-markdown
                        v-if="nodes.critical.markdown && nodes.critical.markdown.elements"
                        :elements="nodes.critical.markdown.elements"
                    />
                    <ui-layout gap="2">
                        <ui-button
                            v-if="showFix"
                            label="Fix authentication"
                            type="primary"
                            size="sm"
                            icon-right="fa-external-link-alt"
                            @click.prevent="openFix"
                        />
                        <ui-button
                            v-if="goScriptUrl"
                            label="Open GoScript Editor"
                            type="outline"
                            size="sm"
                            icon-right="fa-external-link-alt"
                            @click.prevent="openGoScript"
                        />
                    </ui-layout>
                </ui-panel-base>

                <ui-panel-base v-if="nodes.error" color="light-slate" align="center" justify="start" gap="2">
                    <ui-image
                        v-if="isImage"
                        :src="nodes.error.download_url"
                        placeholder="Loading..."
                        size="sm"
                        :handler="() => $emit('view-image', nodes.error)"
                    />
                    <ui-layout direction="column" align="start" gap="2">
                        <apck-narrative-meta
                            :timestamp="nodes.error.timestamp"
                            :verbosity="nodes.error.verbosity"
                            :file-type="nodes.error.file_type"
                        />
                        <apck-data-markdown
                            v-if="nodes.error.markdown && nodes.error.markdown.elements"
                            :elements="nodes.error.markdown.elements"
                        />
                        <ui-layout gap="2">
                            <ui-button
                                v-if="isImage"
                                label="View image"
                                type="primary"
                                size="sm"
                                @click.prevent="$emit('view-image', nodes.error)"
                            />
                            <ui-button
                                label="Details"
                                type="outline"
                                size="sm"
                                @click.prevent="$emit('details')"
                            />
                        </ui-layout>
                    </ui-layout>
                </ui-panel-base>
            </ui-layout>
        </div>
    `,
};
